import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './about-us/about-us.component';
import { TermsNConditionsComponent } from './terms-n-conditions/terms-n-conditions.component';
import { ResponsibleGamingComponent } from './responsible-gaming/responsible-gaming.component';
import { CelebsLoveUsComponent } from './celebs-love-us/celebs-love-us.component';

const routes: Routes = [
  {
    path: "celbsloveus",
    component: CelebsLoveUsComponent,
  },
  {
    path: "aboutus",
    component: AboutUsComponent,
  },
  {
    path: "terms",
    component: TermsNConditionsComponent,
  },
  {
    path: "gaming",
    component: ResponsibleGamingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StaticPagesRoutingModule { }
